<template>
    <h1>Welcome</h1>
</template>

<script>
export default {
    name: 'Login',
    created(){
    }
}
</script>